
export const data = [
    {
        id:"1",
        name:"Men's Cotton Blend blue T-Shirt",
        image:"https://fakestoreapi.com/img/71YXzeOuslL._AC_UY879_.jpg",
        price:199,
        category:"men"

    },
    {
        id:"2",
        name:"Men's Printed Casual Shirt",
        image:"https://rukminim1.flixcart.com/image/832/832/l2xmqvk0/shirt/z/i/x/m-ad-egypt-shirt-02-ak-impex-original-image5xzxaazchh8.jpeg?q=70",
        price:399,
        category:"men"

    },
    {
        id:"3",
        name:"John Hardy Women's ",
        image:"https://fakestoreapi.com/img/71pWzhdJNwL._AC_UL640_QL65_ML3_.jpg",
        price:6950,
        category:"jewellery"
    },
    {
        id:"4",
        name:"boAt Rockerz450 Bluetooth On Ear Headphones with Mic",
        image:"https://m.media-amazon.com/images/I/51xxA+6E+xL._SX522_.jpg",
        price:1999,
        category:"electric"
    },
    {
        id:"5",
        name:"Cuban Silver Bracelet for Men Boys",
        image:"https://m.media-amazon.com/images/I/512hvqlxOuL._UY625_.jpg",
        price:2199,
        category:"jewellery"
    },
    {
        id:"6",
        name:"Laptop Backpack with USB Charging Port | Multi functional Bagpack (Grey)",
        image:"https://m.media-amazon.com/images/I/51rga1GR6rL.jpg",
        price:1099,
        category:"men"
    },
    {
        id:"7",
        name:"Noise Twist Bluetooth Calling Smart Watch ",
        image:"https://m.media-amazon.com/images/I/61TapeOXotL._SX679_.jpg",
        price:2199,
        category:"electric"
    },
    {
        id:"8",
        name:"HP All-in-One Desktop PC (8GB/256GB SSD + 1TB HDD/FHD",
        image:"https://m.media-amazon.com/images/I/61ogPth2lzL._SX679_.jpg",
        price:45999,
        category:"electric"
    },
    {
        id:"9",
        name:"Women's Hoodies",
        image:"https://m.media-amazon.com/images/I/51CbQi8QLzL._UX466_.jpg",
        price:2999,
        category:"women"
    },
    {
        id:"10",
        name:" Women's Sweatshirt 'M' size Pink ",
        image:"https://m.media-amazon.com/images/I/71eq6q3uVeL._AC_UY1100_.jpg",
        price:3499,
        category:"women"
    },
    {
        id:"11",
        name:"Gold Jewellery Set necklace and earrings",
        image:"https://m.media-amazon.com/images/I/41L6gVqjhQL._AC_UL400_.jpg",
        price:25499,
        category:"jewellery"
    },
    {
        id:"12",
        name:"Women Leather Bag",
        image:"https://m.media-amazon.com/images/I/71Y32csE9vL._UY695_.jpg",
        price:4449,
        category:"women"
    },
    {
        id:"13",
        name:"WildHorn Wallet for Men",
        image:"https://m.media-amazon.com/images/I/914s7a8twcL._SX679_.jpg",
        price:649,
        category:"men"
    },
    {
        id:"14",
        name:"HP Wired Keyboard",
        image:"https://m.media-amazon.com/images/I/31-AngJwVkL._SX300_SY300_QL70_FMwebp_.jpg",
        price:599,
        category:"electric"
    },
    {
        id:"15",
        name:"Foldsack No.1 Backpack",
        image:"https://fakestoreapi.com/img/81fPKd-2AYL._AC_SL1500_.jpg",
        price:1099,
        category:"men"
    },
    {
        id:"16",
        name:"SanDisk SSD PLUS 1TB Internal SSD",
        image:"https://fakestoreapi.com/img/61U7T1koQqL._AC_SX679_.jpg",
        price:699,
        category:"electric"
    },
    {
        id:"17",
        name:"Samsung 49-Inch CHG90 144Hz Curved",
        image:"https://fakestoreapi.com/img/81Zt42ioCgL._AC_SX679_.jpg",
        price:70000,
        category:"electric"
    },
    {
        id:"18",
        name:"Lock and Love Women's Removable Hoodi",
        image:"https://fakestoreapi.com/img/81XH0e8fefL._AC_UY879_.jpg",
        price:2599,
        category:"women"
    },
    {
        id:"19",
        name:"MBJ Women's Solid Short Sleeve Boat..",
        image:"https://fakestoreapi.com/img/71z3kpMAYsL._AC_UY879_.jpg",
        price:799,
        category:"women"
    },
    {
        id:"20",
        name:"Mens Cotton Jacket",
        image:"https://fakestoreapi.com/img/71li-ujtlUL._AC_UX679_.jpg",
        price:1155,
        category:"men"
    },
    {
        id:"21",
        name:"White Gold Plated Ring",
        image:"https://fakestoreapi.com/img/71YAIFU48IL._AC_UL640_QL65_ML3_.jpg",
        price:3999,
        category:"jewellery"
    },

];